import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { Language } from './core/models/language.model';
import { LoginService } from './core/services/login.service';
import { LocalizationService } from './core/services/localization.service';
import { UserService } from './core/services/user.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {

  get isAuthenticated(): boolean {
    return this.loginService.isAuthenticated();
  }

  get isDddUser(): boolean {
    return this.userService.isDddUser();
  }

  get isLoading(): boolean {
    return this.localizationService.isLoadingTranslations();
  }

  get userName(): string {
    return this.userService.getUserName();
  }

  get languages(): Language[] {
    return this.userService.getLanguages();
  }

  get language$(): Observable<Language> {
    return this.localizationService.getLanguage();
  }

  constructor(
    private loginService: LoginService,
    private userService: UserService,
    private localizationService: LocalizationService
  ) { }

  ngOnInit(): void {
    if (this.isAuthenticated) {
      this.loginService.onLoginSuccess();
    }
  }

  onLanguageChanged(language: Language) {
    this.localizationService.updateLanguageSettings(language);
  }

  onLogout() {
    if (confirm('Logout from DDD app?')) {
      this.loginService.logout();
    }
  }

}